import { connect } from 'react-redux';
import { get } from 'lodash';

import { showFoodProfileMobileSidebar } from 'apps/foodProfile/actions/foodProfile';

import { withMediaQueryDesktop } from 'utils/mediaQueries/withMediaQueries';
import FoodProfileMobileSidebarHandler from '../../components/sidebar/FoodProfileMobileSidebarHandler';
import { BetaFeatures as FoodProfileBetaFeatures } from 'apps/foodProfile/consts';

export default connect(
  state => ({
    isFoodMaestroEnabled: get(state, 'user.betaFeatures', []).includes(FoodProfileBetaFeatures.FOODMAESTRO_ENABLED),
  }),
  {
    showFoodProfileMobileSidebar,
  }
)(withMediaQueryDesktop(FoodProfileMobileSidebarHandler));
